export const enum EventStatus {
    Pending = 0,
    InProgress = 1,
    Success = 2,
    Fail = 3
}